import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-score-summary',
  templateUrl: './score-summary.component.html'
})
export class ScoreSummaryComponent extends ReportShareComponent {

  get coachingStyleHeight(): number {
    return this.download ? 330 : 400
  }
  
  get directIndirectHeight(): number {
    return this.download ? 130 : 150
  }

  get preferenceScore(): string {
    if (this.isFacilitator) {
      return "Your RESPECT Facilitator Styles™ Scores";
    }

    if (this.isDirectReport) {
      return "Their RESPECT Direct Report Preferences™ Scores";
    } else if (this.isPeerToPeer) {
      return "Their RESPECT Peer-to-Peer Report Style Preference™ Scores";
    } else if (this.isCoacheePreference) {
      return "Their RESPECT Coachee Preference™ Scores";
    }
    return "";
  }

  get expressionScore(): string {
    if (this.isFacilitator) {
      return "Your Style Expression Scores";
    }

    if (this.isDirectReport) {
      return "Their RESPECT Direct Report Preferences™ Expression Scores";
    } else if (this.isPeerToPeer) {
      return "Their RESPECT Peer-to-Peer Report Style Preference™ Expression Scores";
    } else if (this.isCoacheePreference) {
      return "Their RESPECT Coachee Preference™ Expression Scores";
    }
    return "";
  }
}
